export var Log = 'log';
export var Pow = 'pow';
export var Utc = 'utc';
export var Sqrt = 'sqrt';
export var Band = 'band';
export var Time = 'time';
export var Point = 'point';
export var Linear = 'linear';
export var Ordinal = 'ordinal';
export var Quantile = 'quantile';
export var Quantize = 'quantize';
export var Threshold = 'threshold';
export var BinLinear = 'bin-linear';
export var BinOrdinal = 'bin-ordinal';
export var Sequential = 'sequential';
